<script>
export default {
  name: 'MaterialCategoryItemRecursive',
  props: {
    id: String,
    items: Array,
  },
  data() {
    return {
      collapsed: false,
    };
  },
  computed: {
    item() { return this.items.find(item => item['@id'] === this.id); },
    children() { return this.items.filter(item => (!this.id && !item?.parent) || item?.parent === this.id); },
  },
};
</script>

<template lang="pug">
.material-category-item-recursive
  .item
    Btn(xs green @click="$emit('add', item)")
      Icon(name="plus" pointer colored)
    template(v-if="item")
      Btn(xs blue @click="$emit('edit', item)")
        Icon(name="edit" pointer colored)
      Btn(xs grey @click="$emit('del', item)")
        Icon(name="cross" pointer colored)
    Btn(v-if="children.length" xs grey transparent @click="collapsed = !collapsed")
      Icon(name="angle-down" pointer colored :class="collapsed ? 'down' : 'up'")
    .name(v-if="item") {{ item && item.name }}
    .name(v-else) root
  .children(v-if="children.length && !collapsed")
    MaterialCategoryItemRecursive(
      v-for="child in children"
      :key="child.id"
      :id="child['@id']"
      :items="items"
      @add="$emit('add', $event)"
      @edit="$emit('edit', $event)"
      @del="$emit('del', $event)"
    )
</template>

<style scoped lang="scss">
::v-deep .button {
  padding: 3px 5px;
  aspect-ratio: 1;
}

.item {
  display: flex;
  gap: 10px;
  padding: 5px;
}

.up {
  transform: rotate(180deg);
}

.children {
  padding-left: 30px;
}
</style>
